import axios from 'axios';

export default {
    FETCH_PLANS ({commit, dispatch}){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.get('plans')
                .then((response) => {
                    const { data: { data } } = response;
                    localStorage.setItem('plans', JSON.stringify(data));
                    commit('SET_PLANS', data);
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },

    GET_SELECTED_PLAN ({ commit }, packageId) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.get(`/plans/${packageId}`)
                .then((response) => {
                    commit('TOGGLE_LOADING', false);
                    const { data: { data } } = response;
                    commit('SET_SELECTED_PLAN', data);
                    console.log('GET_SELECTED_PLAN data ', data);
                    console.log('GET_SELECTED_PLAN response ', response);
                    resolve(data);
                })
                .catch((error) => {
                    commit('TOGGLE_LOADING', false);
                    console.log('GET_SELECTED_PLAN error ', error);
                    reject(error);
                });
        })
    },

    DELETE_SELECTED_PLAN ({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.delete(`/plans/${params.packageId}?isDelete=${params.isDelete}`)
                .then((response) => {
                    commit('TOGGLE_LOADING', false);
                    const { data: { data } } = response;
                    console.log('DELETE_SELECTED_PLAN response ', response);
                    resolve(data);
                })
                .catch((error) => {
                    commit('TOGGLE_LOADING', false);
                    console.log('DELETE_SELECTED_PLAN error ', error);
                    reject(error);
                });
        })

    },

    UPDATE_PLAN({commit, dispatch}, obj){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.put(`plans/${obj.id}`, obj.payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_EVENT action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },

    ADD_PLAN({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add plan payload : ", payload);
            axios.post('plans', payload)
                .then((response) => {
                    console.log('ADD_PLAN action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_PLAN action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/plans/actions.js